
import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { Organisation } from '@/models/organisation'

@Component({
  components: {
  },
})
export default class JobTitlesForm extends Vue {
  @Prop() public pending!: boolean
  @Prop() private readonly jobTitles!: string[]
  @Prop() private readonly org!: Organisation[]

  private mounted() {
  }

}
